import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
import { APP_CONTEXT, PAGE_TYPES } from './constants';
const ModelProps = {
    url: types.maybe(types.string),
    lastProfileUrl: types.maybe(types.string),
    type: types.optional(types.enumeration('PAGE_TYPES', Object.values(PAGE_TYPES)), PAGE_TYPES.UNKNOWN),
    appContext: types.optional(types.enumeration('APP_CONTEXT', Object.values(APP_CONTEXT)), APP_CONTEXT.PROSPECT),
    parserResult: types.maybe(types.string),
    pathName: types.maybe(types.string),
    isContactTagsPopupOpen: types.optional(types.boolean, false),
    contactTagsPopupPosition: types.optional(types.string, 'plugin_tag'),
    isSessionExpired: types.optional(types.boolean, false),
};
const UserSettings = types.model(ModelProps).actions(Actions).views(Views);
export default UserSettings;
